import { render, staticRenderFns } from "./MemberItemNotify.vue?vue&type=template&id=943cf990&scoped=true"
import script from "./MemberItemNotify.vue?vue&type=script&lang=js"
export * from "./MemberItemNotify.vue?vue&type=script&lang=js"
import style0 from "./MemberItemNotify.vue?vue&type=style&index=0&id=943cf990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943cf990",
  null
  
)

export default component.exports